/**
 * feature setting gating the retailer experience in australia and canada.
 * https:www.notion.so/faire/Insider-CAN-AUS-retailers-launch-35f9d7cd3b5e424984dd9f04dbf6cf4e
 * Product Area: INSIDER
 */
export const ENABLE_INSIDER_AUS_CAN_M2_RETAILERS_LAUNCH_240910 = 'ENABLE_INSIDER_AUS_CAN_M2_RETAILERS_LAUNCH_240910';
